import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const RISK = {
  Low: { bg: "#DCFCE7", color: "#166534" },
  Medium: { bg: "#FEF3C7", color: "#854D0E" },
  High: { bg: "#FFE4E6", color: "#9F1239" },
  Critical: { bg: "#FEE2E2", color: "#7F1D1D" },
};
const STATUS = {
  Approved: { bg: "#DBEAFE", color: "#1E40AF" },
  "In Progress": { bg: "#FEF3C7", color: "#854D0E" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
  Expired: { bg: "#FEE2E2", color: "#7F1D1D" },
  Rejected: { bg: "#F1F5F9", color: "#334155" },
};

export default function PermitToWork() {
  const { data, siteNames } = useHSE();
  const stats = ["Approved", "In Progress", "Closed", "Expired", "Rejected"].map((s) => ({ s, n: data.ptws.filter((p) => p.status === s).length }));

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      {stats.map((x) => (
        <div key={x.s} className="command-card p-3.5">
          <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{x.s}</div>
          <div className="font-heading font-bold text-2xl tabular text-[#0E2336] mt-0.5">{x.n}</div>
        </div>
      ))}
    </div>
  );

  return (
    <RegisterPage
      title="Permit to Work"
      subtitle="High-risk activity permits & approvals"
      storeKey="ptws"
      idPrefix="PTW"
      topPanels={Top}
      columns={[
        { key: "id", label: "PTW ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "workType", label: "Work Type" },
        { key: "location", label: "Location" },
        { key: "contractor", label: "Contractor" },
        { key: "issuer", label: "Issuer" },
        { key: "approver", label: "Approver" },
        { key: "startTime", label: "Start" },
        { key: "endTime", label: "End" },
        { key: "risk", label: "Risk" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ risk: RISK, status: STATUS }}
      formFields={[
        { key: "id", label: "PTW ID" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "workType", label: "Work Type", type: "select", options: ["Hot Work", "Confined Space", "Working at Height", "Electrical", "Excavation", "Lifting"] },
        { key: "location", label: "Location" },
        { key: "contractor", label: "Contractor", type: "select", options: data.settings.contractors },
        { key: "issuer", label: "Issuer" },
        { key: "approver", label: "Approver" },
        { key: "startTime", label: "Start Time", type: "time" },
        { key: "endTime", label: "End Time", type: "time" },
        { key: "risk", label: "Risk Level", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "status", label: "Status", type: "select", options: ["Approved", "In Progress", "Closed", "Expired", "Rejected"] },
      ]}
    />
  );
}
